import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../component/Header';
import Footer from '../component/Footer';
import MonekPaymentForm from '../component/MonekPaymentForm';
import LeftMenu from '../component/LeftMenu'; // Import LeftMenu
import bannerImage from './../assets/images/banner.png'; // Import banner image
import { Container, Row, Col } from 'react-bootstrap';


const Address = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { paymentModel } = location.state || {};
    const [addressCorrect, setAddressCorrect] = useState('yes');
    const [showPayment, setShowPayment] = useState(false);
    const [contactNumber, setContactNumber] = useState(paymentModel?.phone || '01234567890');
    const [contactEmail, setContactEmail] = useState(paymentModel?.Email || 'gavin.chitticks@paragon-uk.net');
    const [communicationPreferences, setCommunicationPreferences] = useState(['Post', 'Email', 'Text message', 'Telephone']);
    const [password, setPassword] = useState('');

    // Fallback if accessed directly
    useEffect(() => {
        if (!paymentModel) {
            // navigate('/product'); 
        }
    }, [paymentModel, navigate]);

    if (!paymentModel) return <div className="page-main-area"> <Header /><Container><div className="product-details-left mt-5 text-center">Loading... (No payment data found)</div></Container><Footer /></div>;

    const {
        TotalToPay,
        Address1,
        Address2,
        Address3,
        Postcode,
        Email,
        Name,
        Reference,
        PaymentReference,
        payment,
        Insurer,
        phone,
        schemeCode,
        coverDate,
        pReturn,
        pCode,
        pRef,
        currentInsurerCharge,
        legalPurchased,
        emergencyPurchased,
        keysPurchased,
        gadgetPurchased
    } = paymentModel;

    // Construct a dummy selectInsurerType object for LeftMenu if needed, or pass null
    const selectInsurerType = { type: 'currentInsurer' }; // Default or derive from paymentModel if possible
    const productBothPrices = false; // Default or derive

    const handleSubmit = (e) => {
        e.preventDefault();
        // Navigate to payment page with paymentModel
        navigate('/payment', { state: { paymentModel } });
    };

    return (
        <div className="page-main-area">
            <Header />
            <div className='product-page-main-area'>
                {/* <div className='banner-main'>
                    <img src={bannerImage} alt="banner" />
                </div> */}
                <Container fluid>
                    <Container>
                        <Row>
                            <Col md={9}>
                                <div className='product-details-left'>
                                    {showPayment ? (
                                        <div style={{ minHeight: '600px', display: 'flex', justifyContent: 'center', paddingTop: '50px' }}>
                                            <MonekPaymentForm model={paymentModel} isTest={true} embed={true} />
                                        </div>
                                    ) : (<>
                                        {/* 
                                    <form onSubmit={handleSubmit} name="basketform" id="basketform" autoComplete="off">
                                            <div className="secure-payment-header d-flex align-items-center mb-4">
                                                <img src="https://thamesbankassets.netlify.app/padlock_small.png" alt="Secure Payment" className="me-2" style={{ width: '24px' }} />
                                                <h4 className="mb-0 text-dark fw-bold">Secure Payment</h4>
                                            </div>

                                            <div className="mb-4">
                                                <p className="mb-3">
                                                    To complete your purchase we require a payment for the amount of <strong>GBP {TotalToPay}</strong>.<br />
                                                    Please note: By entering card information you are confirming you are the card holder. If you are not the card holder, cover can only be arranged over the telephone with the card holder present
                                                </p>
                                                <p className="mb-4">
                                                    Please enter your credit or debit card details below. This is a secure SSL encrypted service ensuring the safety of your information.
                                                </p>
                                            </div>

                                            <Row className="mb-3 align-items-center">
                                                <Col md={5}>
                                                    <label htmlFor="cardtype" className="form-label fw-bold mb-0">Card Type</label>
                                                    <div className="text-muted small">Which card would you like to pay with?</div>
                                                </Col>
                                                <Col md={7}>
                                                    <select id="cardtype" className="form-select" name="cardType">
                                                        <option value="Visa">Visa</option>
                                                        <option value="Mastercard">Mastercard</option>
                                                        <option value="Delta">Delta</option>
                                                        <option value="Switch/Maestro">Switch/Maestro</option>
                                                    </select>
                                                </Col>
                                            </Row>

                                            <Row className="mb-3 align-items-center">
                                                <Col md={5}>
                                                    <label htmlFor="cardholdersname" className="form-label fw-bold mb-0">Card Holder's Name</label>
                                                    <div className="text-muted small">Your name as it appears on your card</div>
                                                </Col>
                                                <Col md={7}>
                                                    <input id="cardholdersname" type="text" maxLength="40" className="form-control" name="cardholdersname" required />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3 align-items-center">
                                                <Col md={5}>
                                                    <label htmlFor="cardnumber" className="form-label fw-bold mb-0">Card Number</label>
                                                    <div className="text-muted small">The 16 digits on the front of your card</div>
                                                </Col>
                                                <Col md={7}>
                                                    <input id="cardnumber" type="text" maxLength="20" className="form-control" name="cardnumber" required />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3 align-items-center">
                                                <Col md={5}>
                                                    <label htmlFor="cv2" className="form-label fw-bold mb-0">Security Number (CV2)</label>
                                                    <div className="text-muted small">The last 3 digits on the back of your card</div>
                                                </Col>
                                                <Col md={7}>
                                                    <input id="cv2" type="text" maxLength="4" className="form-control" name="cv2" required />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3 align-items-center">
                                                <Col md={5}>
                                                    <label className="form-label fw-bold mb-0">Expiry Date</label>
                                                    <div className="text-muted small">Find this on the front of your card</div>
                                                </Col>
                                                <Col md={7}>
                                                    <div className="d-flex gap-3">
                                                        <select id="cardexpiremonth" className="form-select flex-fill" name="cardexpiremonth">
                                                            <option value="01">01</option>
                                                            <option value="02">02</option>
                                                            <option value="03">03</option>
                                                            <option value="04">04</option>
                                                            <option value="05">05</option>
                                                            <option value="06">06</option>
                                                            <option value="07">07</option>
                                                            <option value="08">08</option>
                                                            <option value="09">09</option>
                                                            <option value="10">10</option>
                                                            <option value="11">11</option>
                                                            <option value="12">12</option>
                                                        </select>
                                                        <select id="cardexpireyear" className="form-select flex-fill" name="cardexpireyear">
                                                            <option value="25">2025</option>
                                                            <option value="26">2026</option>
                                                            <option value="27">2027</option>
                                                            <option value="28">2028</option>
                                                            <option value="29">2029</option>
                                                            <option value="30">2030</option>
                                                            <option value="31">2031</option>
                                                            <option value="32">2032</option>
                                                            <option value="33">2033</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Col md={5}>
                                                    <label className="form-label fw-bold mb-0">Address card is registered to</label>
                                                </Col>
                                                <Col md={7}>
                                                    <div className="p-0">
                                                        {Address1 && <div>{Address1}</div>}
                                                        {Address2 && <div>{Address2}</div>}
                                                        {Address3 && <div>{Address3}</div>}
                                                        {Postcode && <div>{Postcode}</div>}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className="mb-3 align-items-center">
                                                <Col md={5}>
                                                    <label htmlFor="control_Payment-CardAddressCorrect" className="form-label fw-bold mb-0">Is this the correct address for this card?</label>
                                                </Col>
                                                <Col md={7}>
                                                    <select
                                                        id="control_Payment-CardAddressCorrect"
                                                        className="form-select"
                                                        name="cardAddressCorrect"
                                                        value={addressCorrect}
                                                        onChange={(e) => setAddressCorrect(e.target.value)}
                                                    >
                                                        <option value="yes">Yes</option>
                                                        <option value="no">No</option>
                                                    </select>
                                                </Col>
                                            </Row>

                                            {addressCorrect === 'no' && (
                                                <div className="mt-3 mb-4 border-top pt-3">
                                                    <Row className="mb-3 align-items-center">
                                                        <Col md={5}>
                                                            <label className="form-label fw-bold mb-0">Address card is registered to</label>
                                                        </Col>
                                                        <Col md={7}>
                                                            <input type="text" maxLength="30" className="form-control mb-2" name="cardHolderAddr1" defaultValue={Address1} placeholder="Address Line 1" />
                                                            <input type="text" maxLength="30" className="form-control mb-2" name="cardHolderCity" defaultValue={Address2} placeholder="Address Line 2" />
                                                            <input type="text" maxLength="30" className="form-control mb-2" name="cardHolderState" defaultValue={Address3} placeholder="Address Line 3" />
                                                            <input type="text" maxLength="10" className="form-control" name="cardHolderPostcode" defaultValue={Postcode} placeholder="Postcode" />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )}

                                            <div id="validationMessage" className="mb-3">
                                                <label id="lblError" className="text-danger"></label>
                                            </div>

                                            <div className="d-flex justify-content-end mb-5">
                                                <button className="btn btn-primary btn-lg" type="submit">Complete your purchase</button>
                                            </div>

                                            <div className="bg-light p-3 rounded d-flex align-items-center gap-3">
                                                <div className="flex-grow-1">
                                                    <strong>Your Security</strong>
                                                    <div className="small text-muted">
                                                        Your transaction is protected by 256-bit SSL encryption. Our secure payment gateway is powered by GoDaddy, ensuring your data remains private and protected throughout the process.
                                                    </div>
                                                </div>
                                                <div>
                                                    <img src="https://thamesbankassets.netlify.app/godaddy_dark.png" alt="GoDaddy Security" style={{ width: '120px' }} />
                                                </div>
                                            </div>
                                        </form> 
                                        */}

                                        <form onSubmit={handleSubmit} className="p-4">
                                            <h4 className="mb-3">Please confirm your details</h4>
                                            <p className="text-muted mb-4" style={{ fontSize: '0.95rem' }}>
                                                Ensure the following details are correct as this information is used to issue your Policy Documents which are uploaded to a secure document portal.
                                            </p>

                                            {/* Section with background color */}
                                            <div className="p-4" style={{ backgroundColor: 'rgb(232, 244, 248)', borderRadius: '8px' }}>
                                                {/* Contact Number */}
                                                <div className="mb-4">
                                                    <label className="form-label fw-bold mb-1">
                                                        Contact number <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="text-muted small mb-2" style={{ fontSize: '0.85rem' }}>
                                                        So we can contact you if there's a problem
                                                    </div>
                                                    <input 
                                                        type="tel" 
                                                        className="form-control" 
                                                        value={contactNumber} 
                                                        onChange={(e) => setContactNumber(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                {/* Contact Email */}
                                                <div className="mb-4">
                                                    <label className="form-label fw-bold mb-1">
                                                        Contact email address <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="text-muted small mb-2" style={{ fontSize: '0.85rem' }}>
                                                        So we can contact you if there's a problem
                                                    </div>
                                                    <input 
                                                        type="email" 
                                                        className="form-control" 
                                                        value={contactEmail} 
                                                        onChange={(e) => setContactEmail(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                {/* Contacting You Section */}
                                                <div className="mb-4">
                                                    <h5 className="fw-bold mb-2">Contacting You</h5>
                                                    <p className="text-muted small mb-3" style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                                                        If you agree, every now and then we'd like to contact you by Email, Post, Telephone or Text regards everyday general insurance products and services we offer which we feel maybe beneficial to you.
                                                    </p>
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {['Post', 'Email', 'Text message', 'Telephone'].map((pref) => (
                                                            <button
                                                                key={pref}
                                                                type="button"
                                                                className={`btn ${communicationPreferences.includes(pref) ? 'btn-primary' : 'btn-outline-primary'}`}
                                                                onClick={() => {
                                                                    if (communicationPreferences.includes(pref)) {
                                                                        setCommunicationPreferences(communicationPreferences.filter(p => p !== pref));
                                                                    } else {
                                                                        setCommunicationPreferences([...communicationPreferences, pref]);
                                                                    }
                                                                }}
                                                                style={{ 
                                                                    minWidth: '120px',
                                                                    borderRadius: '4px',
                                                                    fontSize: '0.9rem'
                                                                }}
                                                            >
                                                                {pref}
                                                            </button>
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* Help Link */}
                                                <div className="mb-0">
                                                    <a href="#" className="text-decoration-none" style={{ color: '#0066cc', fontSize: '0.9rem' }}>
                                                        <span className="me-2" style={{ fontSize: '1.1rem' }}>?</span>
                                                        Need more help with this question?
                                                    </a>
                                                </div>
                                            </div>

                                            {/* Total to Pay */}
                                            {/* <div className="my-4 p-3 bg-light rounded text-end">
                                                <h4 className="mb-0">
                                                    Total to Pay: <strong>£{TotalToPay}</strong>
                                                </h4>
                                            </div> */}

                                            {/* Submit Button */}
                                            {/* <div className="d-flex justify-content-end">
                                                <button className="btn btn-primary btn-lg" type="submit">Complete your purchase</button>
                                            </div> */}
                                        </form>

                                        {/* Create an online account section */}
                                        <div className="mt-5 p-4" style={{ backgroundColor: '#ffffff',
                                             borderRadius: '8px',
                                            //   border: '1px solid #e0e0e0' 
                                              }}>
                                            <div className="d-flex align-items-center mb-3">
                                                {/* <span className="me-2" style={{ fontSize: '1.2rem', color: '#999' }}>👆</span> */}
                                                <h4 className="mb-0 fw-bold">Create an online account</h4>
                                            </div>

                                            <div className="p-4" style={{ backgroundColor: 'rgb(232, 244, 248)', borderRadius: '8px' }}>
                                                <p className="mb-3" style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#333' }}>
                                                    In order to reduce our carbon footprint, we are paperless. All policy documentation will be uploaded to a secure portal. You can create your password here but will receive an invitation email shortly after purchase, where you can register and create an account.
                                                </p>

                                                <p className="mb-4" style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#333' }}>
                                                    We understand that you may require paper copies of your documentation. If this is the case, please feel free to contact us. However, we would highly recommend that you still register on the portal as future communications about your policy including renewal notifications will be uploaded there.
                                                </p>

                                                {/* Password Input */}
                                                <div className="mb-4">
                                                    <label className="form-label fw-bold mb-1">
                                                        Please enter your password
                                                    </label>
                                                    <div className="text-muted small mb-2" style={{ fontSize: '0.85rem', color: '#666' }}>
                                                        Your password must contain capital and lower case letters, at least one number and be at least 8 characters long
                                                    </div>
                                                    <input 
                                                        type="password" 
                                                        className="form-control" 
                                                        value={password} 
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        placeholder="Please enter..."
                                                        style={{ borderColor: '#ccc' }}
                                                    />
                                                </div>

                                                {/* Help Link */}
                                                <div className="mb-0">
                                                    <a href="#" className="text-decoration-none d-inline-flex align-items-center" style={{ color: '#0066cc', fontSize: '0.9rem' }}>
                                                        <span className="me-2 d-inline-flex align-items-center justify-content-center" style={{ 
                                                            width: '20px', 
                                                            height: '20px', 
                                                            borderRadius: '50%', 
                                                            backgroundColor: '#666', 
                                                            color: '#fff', 
                                                            fontSize: '0.85rem',
                                                            fontWeight: 'bold'
                                                        }}>?</span>
                                                        Need more help with this question?
                                                    </a>
                                                </div>
                                            </div>

                                            {/* Navigation Buttons */}
                                            <div className="d-flex justify-content-between mt-4">
                                                <button 
                                                    type="button" 
                                                    className="btn" 
                                                    onClick={() => navigate(-1)}
                                                    style={{ 
                                                        backgroundColor: '#1C8552', 
                                                        color: '#fff', 
                                                        borderRadius: '6px',
                                                        padding: '10px 30px',
                                                        fontWeight: '500',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                    }}
                                                >
                                                    Previous
                                                </button>
                                                <button 
                                                    type="button" 
                                                    className="btn" 
                                                    onClick={handleSubmit}
                                                    style={{ 
                                                        backgroundColor: '#0066cc', 
                                                        color: '#fff', 
                                                        borderRadius: '6px',
                                                        padding: '10px 30px',
                                                        fontWeight: '500',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                    }}
                                                >
                                                    Continue
                                                </button>
                                            </div>
                                        </div>
                                    </>)}
                                </div>
                            </Col>
                            <Col md={3} className="d-none d-md-block">
                                {/* Quote Reference Box */}
                                <div className="mb-3 p-4 text-white rounded" style={{ backgroundColor: '#1C8552' }}>
                                    <h5 className="mb-1" style={{ fontSize: '0.9rem' }}>Quote Reference</h5>
                                    <h3 className="mb-3 fw-bold">{Reference}</h3>
                                    <hr className="my-3" style={{ opacity: 0.5, borderColor: 'white' }} />
                                    <p className="mb-1" style={{ fontSize: '0.9rem' }}>If you need help call us on</p>
                                    <h3 className="mb-3 fw-bold">0203 302 9263</h3>
                                    <hr className="my-3" style={{ opacity: 0.5, borderColor: 'white' }} />
                                    <h5 className="mb-0">Home Insurance</h5>
                                </div>

                                {/* Your Security Box */}
                                <div className="mb-3 p-4 bg-white rounded shadow-sm">
                                    <h4 className="fw-bold mb-3" style={{ fontSize: '1.2rem' }}>Your security:</h4>
                                    <p className="small mb-3">Your information is secured with a 256 bit SSL connection provided by our technology partner GoDaddy.</p>
                                    <img src="https://thamesbankassets.netlify.app/godaddy_dark.png" alt="GoDaddy Verified & Secured" className="img-fluid" />
                                </div>

                                {/* Contact Us Box */}
                                <div className="mb-3 p-4 text-white rounded" style={{ backgroundColor: '#333' }}>
                                    <h4 className="fw-bold mb-3" style={{ fontSize: '1.2rem' }}>Contact us:</h4>
                                    <p className="mb-1 small">Call us on our phone number</p>
                                    <h4 className="mb-3 fw-bold">0203 302 9263</h4>

                                    <p className="mb-1 small">Email:</p>
                                    <p className="mb-3 fw-bold" style={{ fontSize: '0.9rem' }}>sales@thamesbankinsurance.co.uk</p>

                                    <h4 className="fw-bold mb-2" style={{ fontSize: '1.2rem' }}>Office Hours:</h4>
                                    <p className="mb-1 fw-bold">Mon to Thur</p>
                                    <p className="mb-2 small">9.00 am to 6.30 pm</p>
                                    <p className="mb-3 small">Fri 9.00 am to 5.30 pm</p>

                                    <p className="small lh-sm" style={{ fontSize: '0.75rem', opacity: 0.8 }}>
                                        Thamesbank Insurance Services is a trading name of Paragon Car Limited and are authorised and regulated by the Financial Conduct Authority, FCA no: 312028
                                    </p>
                                </div>

                                {/* Payment Options Box */}
                                <div className="mb-3 p-4 bg-white rounded shadow-sm">
                                    <h4 className="fw-bold mb-3" style={{ fontSize: '1.2rem' }}>Payment options:</h4>
                                    <p className="small mb-3">We accept all major credit and debit cards and offer payment by monthly instalments under the Direct Debit Guarantee</p>
                                    <img src="https://thamesbankassets.netlify.app/cardLogos.png" alt="Visa Mastercard Maestro Direct Debit" className="img-fluid" />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </div>
            <Footer />
        </div >
    );
};

export default Address;
